import { InfoCircleOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import React, { FC, Fragment } from "react"
export interface InfoFieldProps {
    tooltipText?: string,
    fileURL?: string
}
export const InfoField: FC<InfoFieldProps> = ({ tooltipText, fileURL }) => {
    let suffix: JSX.Element = <Fragment />
    let iconProps: any = { // AntdIconProps
        style: { color: 'rgba(0,0,0,.45)' }
    }
    if (fileURL) {
        iconProps.onClick = () => window.open(fileURL, "_blank")
    }
    if (tooltipText) {
        suffix = (
            <Tooltip title={<div dangerouslySetInnerHTML={{ __html: tooltipText }} />}>
                <InfoCircleOutlined {...iconProps} aria-hidden={true} />
            </Tooltip>
        )
    } else if (fileURL) {
        suffix = <InfoCircleOutlined {...iconProps} aria-hidden={true} />
    }
    return suffix
}